import {Layout, Button, Badge, Avatar, Dropdown, Menu, Space, Select} from 'antd';
import logo from 'assets/img/logo.png';
import UrlConfig from 'config/url.config';
import {Link} from 'react-router-dom';
import {FiMenu} from 'react-icons/fi';
import {RiNotification2Line, RiArrowDropDownLine} from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import { logoutAction } from 'domain/actions/auth/auth.action';
import { selectClientAction, fetchClientsRequestAction } from 'domain/actions/client.action';
import { useState, useEffect } from 'react';
import { RootReducerType } from 'model/reducers/RootReducerType';

interface AccountResponse {
  full_name?: string;
  [key: string]: any;
}

type HeaderContainerProps = {
  onCollapse: () => void;
  account?: AccountResponse | null;
};

const HeaderContainer: React.FC<HeaderContainerProps> = (
  props: HeaderContainerProps
) => {
  const dispatch = useDispatch();
  const { selectedClient, clients } = useSelector((state: RootReducerType) => state.clientReducer);
  const { isVisible: isLoading } = useSelector((state: RootReducerType) => state.loadingReducer);
  const [options, setOptions] = useState<{ value: string, label: string }[]>([]);
  
  // Fetch clients from API
  useEffect(() => {
    // Dispatch action to fetch clients
    dispatch(fetchClientsRequestAction());
  }, [dispatch]);
  
  // Update options when clients change
  useEffect(() => {
    if (clients && clients.length > 0) {
      // Transform client data to dropdown options format
      const clientOptions = clients.map(client => ({
        value: client.id.toString(),
        label: client.name
      }));
      
      setOptions(clientOptions);
      
      // Set default selected value to first client if no client is selected yet
      if (clientOptions.length > 0 && !selectedClient) {
        dispatch(selectClientAction(clients[0]));
      }
    }
  }, [clients, selectedClient, dispatch]);

  const handleChange = (value: string) => {
    // Find the selected client object
    const selectedClientObj = clients.find(client => client.id.toString() === value);
    if (selectedClientObj) {
      // Dispatch action to update Redux store with the full client object
      dispatch(selectClientAction(selectedClientObj));
    }
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="info">
        <Link to="#" type="text">
          <span>Profile</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="logout">
        <Link onClick={()=> dispatch(logoutAction())} to="#" type="text">
          <span>Logout</span>
        </Link>
      </Menu.Item>
    </Menu>
  );
  return (
    <Layout.Header>
      <div className="ant-layout-header-left">
        <Link to={UrlConfig.HOME}>
          <img src={logo} alt="" />
        </Link>
        <div className="header-dropdown">
          <Select
            value={selectedClient?.id.toString() || undefined}
            style={{ width: 180 }}
            onChange={handleChange}
            options={options}
            loading={isLoading}
            placeholder="Select client"
            notFoundContent={isLoading ? "Loading..." : "No clients found"}
          />
        </div>
        <div className="header-right">
          <Button
            onClick={props.onCollapse}
            className="button-menu-collapse"
            icon={<span>{FiMenu({ color: 'black', size: 20 })}</span>}
          />
        </div>
      </div>
      <div className="ant-layout-header-right">
        <Space size={15}>
          <Badge count={0}>
            <Button className="button-notify" icon={<span>{RiNotification2Line({})}</span>} />
          </Badge>
          <Dropdown
            className="layout-user"
            trigger={['click']}
            placement="bottomRight"
            overlay={userMenu}
          >
            <div className="ant-layout-sider-user">
              <Avatar src={props.account?.avatar} size={36} />
              <div className="sider-user-info">{props.account?.fullName}</div>
              <span>{RiArrowDropDownLine({ size: 25, color: "#737373", style: { marginTop: 25 }})}</span>
            </div>
          </Dropdown>
        </Space>
      </div>
    </Layout.Header>
  );
};

export default HeaderContainer;